export const RSACAF_LESSONS = [
  {
    id: 'rsacaf-1',
    numero: 1,
    titre: "Le RSA — comprendre et demander",
    sousTitre: "Vos droits, votre argent",
    contexte: "Vous avez peu ou pas de revenus. Le RSA existe pour vous aider — mais 30% des personnes éligibles ne le demandent pas.",
    explication: [
      "**Le RSA** (Revenu de Solidarité Active) est une aide mensuelle versée par la CAF aux personnes sans ressources suffisantes, à partir de 25 ans.",
      "**Le montant** en 2026 : environ 635€/mois pour une personne seule. Il varie selon votre situation familiale et vos revenus.",
      "**Simulation gratuite** : rendez-vous sur caf.fr ou mesaides.gouv.fr — résultat en 5 minutes, anonyme et sans engagement.",
      "**Pour faire la demande** : connectez-vous sur caf.fr → \'Mes services en ligne\' → \'Faire une demande de RSA\'. Documents nécessaires : pièce d\'identité, RIB, justificatif de domicile, relevés de compte des 3 derniers mois.",
      "**Si vous reprenez un emploi** : le RSA diminue progressivement — il ne s\'arrête pas brutalement. Déclarez vos nouveaux revenus à la CAF.",
    ],
    question: "Vous pensez avoir droit au RSA. Quelle est la première étape ?",
    options: [
      { id: "a", text: "Faire une simulation gratuite sur caf.fr ou mesaides.gouv.fr", correct: true },
      { id: "b", text: "Se déplacer directement à la CAF avec tous vos documents", correct: false },
      { id: "c", text: "Attendre que la CAF vous contacte", correct: false },
    ],
    explication_reponse: "La simulation est gratuite, anonyme et sans engagement. Elle vous donne une estimation en 5 minutes. Commencez toujours par là — vous ne perdez rien à vérifier vos droits.",
  },
  {
    id: 'rsacaf-2',
    numero: 2,
    titre: "Les allocations familiales",
    sousTitre: "Aides pour les familles avec enfants",
    contexte: "Vous avez des enfants. La CAF verse plusieurs aides selon votre situation — bien plus que vous ne le pensez probablement.",
    explication: [
      "**Les allocations familiales classiques** : versées à partir de 2 enfants à charge de moins de 20 ans. Le montant dépend de vos revenus.",
      "**La prime à la naissance** : environ 1000€ versée au 7ème mois de grossesse, sous conditions de ressources. Déclarez votre grossesse à la CAF avant le 3ème mois.",
      "**L\'allocation de base PAJE** : aide mensuelle de la naissance jusqu\'aux 3 ans de l\'enfant, sous conditions de ressources.",
      "**Le complément de libre choix du mode de garde** : aide si votre enfant est gardé par une assistante maternelle ou une crèche agréée.",
      "**Outil indispensable** : caf.fr → \'Simuler mes droits\' pour avoir une estimation complète de TOUTES les aides auxquelles vous avez droit.",
    ],
    question: "Vous attendez un enfant. Quand faut-il prévenir la CAF ?",
    options: [
      { id: "a", text: "Avant la fin du 3ème mois de grossesse", correct: true },
      { id: "b", text: "À la naissance de l\'enfant", correct: false },
      { id: "c", text: "N\'importe quand, il n\'y a pas de délai", correct: false },
    ],
    explication_reponse: "Déclarer la grossesse avant le 3ème mois déclenche toutes les aides. Chaque mois de retard peut vous faire perdre des droits — la prime de naissance notamment est versée au 7ème mois, donc il faut avoir déclaré avant.",
  },
  {
    id: 'rsacaf-3',
    numero: 3,
    titre: "Déclarer ses revenus et changements",
    sousTitre: "Chaque trimestre et à chaque événement",
    contexte: "La CAF a besoin d\'être informée de votre situation en temps réel. Oublier une déclaration peut bloquer vos aides ou créer un indu.",
    explication: [
      "**La déclaration trimestrielle RSA** : obligatoire tous les 3 mois (janvier, avril, juillet, octobre). Si vous oubliez, le versement est suspendu — pas perdu.",
      "**Les changements à déclarer sous 30 jours** : déménagement, naissance, séparation, reprise ou perte d\'emploi, changement de revenus.",
      "**Comment déclarer** : sur caf.fr → \'Mon compte\' → \'Signaler un changement\' ou directement via l\'appli CAF Mon Compte.",
      "**L\'indu** : si vous ne déclarez pas et continuez à recevoir des aides auxquelles vous n\'avez plus droit, la CAF vous demandera de tout rembourser.",
      "**Séparation** : chaque parent crée son propre dossier CAF. Les allocations vont au parent ayant la garde principale.",
    ],
    question: "Vous oubliez votre déclaration trimestrielle RSA. Que se passe-t-il ?",
    options: [
      { id: "a", text: "Le versement est suspendu jusqu\'à votre déclaration — pas perdu définitivement", correct: true },
      { id: "b", text: "Vous perdez définitivement le RSA de ce trimestre", correct: false },
      { id: "c", text: "La CAF fait la déclaration automatiquement à votre place", correct: false },
    ],
    explication_reponse: "Pas de panique en cas d\'oubli — dès que vous faites votre déclaration, le versement reprend. Mettez un rappel dans votre téléphone pour ne plus oublier : janvier, avril, juillet, octobre.",
  },
  {
    id: 'rsacaf-4',
    numero: 4,
    titre: "Utiliser l\'espace CAF en ligne",
    sousTitre: "Tout gérer sans se déplacer",
    contexte: "L\'espace CAF sur caf.fr vous permet de tout gérer depuis chez vous — attestations, paiements, messagerie, déclarations.",
    explication: [
      "**Créez votre compte** sur caf.fr avec votre numéro d\'allocataire (sur vos courriers CAF) et votre date de naissance.",
      "**Ce que vous pouvez faire** : consulter vos paiements, télécharger vos attestations, envoyer des documents, signaler un changement, simuler vos droits.",
      "**L\'attestation CAF** prouve vos droits — demandée pour la cantine, la crèche, un logement social. Téléchargeable en 30 secondes sur caf.fr.",
      "**La messagerie CAF** : envoyez documents et questions directement à votre CAF, sans attente téléphonique ni déplacement.",
      "**L\'appli CAF Mon Compte** : notifications de paiement, attestations, déclarations trimestrielles — tout depuis votre téléphone.",
    ],
    question: "L\'école demande une attestation CAF pour la cantine. Où la trouver rapidement ?",
    options: [
      { id: "a", text: "Sur caf.fr dans votre espace personnel — téléchargeable en 30 secondes", correct: true },
      { id: "b", text: "En vous déplaçant à la CAF avec une pièce d\'identité", correct: false },
      { id: "c", text: "En appelant le 3230 et en attendant un courrier", correct: false },
    ],
    explication_reponse: "L\'attestation CAF se télécharge instantanément sur caf.fr ou l\'appli mobile — disponible 24h/24. C\'est l\'un des documents les plus utiles à avoir toujours sous la main.",
  },
];
